export enum CopilotNotificationStatus {
  Active = 'ACTIVE',
  Testing = 'TESTING',
}
